module.exports = "/_next/static/images/faq-line-0648f9a57b138f395533b4a55e715948.svg";